// Client layer (TS-2.5.03). Renders an AuditEntryDetail's before/after payload readably - each is
// an opaque string (AuditEntryDetail.beforeState/afterState are pre-serialized by the server, not
// typed records this client can parse into fields), so this component's only job is to show them
// legibly (pretty-printed if they happen to be JSON, verbatim otherwise) plus the context map.
import type { AuditEntryDetail } from "../../api/generated/contracts";
import { strings } from "../../strings";

export interface AuditEntryDetailPanelProps {
  readonly detail: AuditEntryDetail;
  readonly onClose: () => void;
}

const S = strings.audit.detail;

function renderPayload(payload: string | null): string {
  if (payload === null) return "—";
  try {
    return JSON.stringify(JSON.parse(payload), null, 2);
  } catch {
    return payload;
  }
}

export function AuditEntryDetailPanel({ detail, onClose }: AuditEntryDetailPanelProps) {
  return (
    <div className="eg-audit-entry-detail" role="region" aria-label={S.heading}>
      <h3>{S.heading}</h3>

      <h4>{S.before}</h4>
      <pre>{renderPayload(detail.beforeState)}</pre>

      <h4>{S.after}</h4>
      <pre>{renderPayload(detail.afterState)}</pre>

      {Object.keys(detail.context).length > 0 && (
        <>
          <h4>{S.context}</h4>
          <dl>
            {Object.entries(detail.context).map(([key, value]) => (
              <div key={key}>
                <dt>{key}</dt>
                <dd>{value}</dd>
              </div>
            ))}
          </dl>
        </>
      )}

      <button type="button" onClick={onClose}>
        {S.close}
      </button>
    </div>
  );
}
